<template>
  <div class="container_val">
    <b-container>
      <b-row class="header">
        <b-col>
          <div @click="back()" style="cursor:pointer;margin-top:20px;">
            <font-awesome-icon style="font-size:28px;cursor:pointer;" :style="{color: getCssColor('primary_bt')}" :icon="['fal', 'times']"/>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row class="grid-center form_container">
        <div class="col-12" style="text-align:center;color:#2C2A29;font-size:16px;font-weight: 500;">
          CÓDIGO DE VALIDAÇÃO
        </div>
        <div class="col-12" style="text-align:center;color:#2C2A29;font-size:16px;font-weight: 500;margin-top:20px;">
          Insira o código de validação enviado pelo SMS/E-Mail
        </div>
        <div class="col-12" style="margin-top:40px;">
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'user-lock']" :style="{color: getCssColor('primary_bt')}"/>
          <input type="number"  class="inputFormText" name="code" placeholder="Código de Validação" v-model="code"/>
        </div>
        
        <div class="col-12" style="margin-top:20px;">
          <div @click="doValidation()" :style="{backgroundColor: getCssColor('primary_bt')}"
            style="margin-top:20px;color:#FFFFFF; cursor:pointer; font-size:14px; font-weight:500; border-radius:4px; height:40px;line-height:40px;text-align:center;">
            VALIDAR
          </div>
        </div>

        <div class="col-12" style="margin-top:20px;">
          <div @click="reSendValidationCode()" :style="{border: '1px solid ' + getCssColor('primary_bt'), color:getCssColor('primary_bt')}"
            style="margin-top:20px;cursor:pointer; font-size:14px; font-weight:500; border-radius:4px; height:40px;line-height:40px;text-align:center;">
            REENVIAR CÓDIGO DE VALIDAÇÃO
          </div>
        </div>
        
      </b-row>
    </b-container>
  </div>
</template>

<script>
import colors from '@/mixins/colors'
import UserConn from '@/connection/user'
import { EventBus } from '@/behaviours/event-bus'
import navigation from '@/mixins/navigation'

export default {
  name: 'ValidationCode',
  data () {
    return {
      code: null,
    }
  },
  mixins: [colors, navigation],

  created () {
    this.$store.state.showLoading = false
  },

  methods: {
    async doValidation() {
      if (this.code && this.code.length === 4) {
        this.$store.state.showLoading = true
        this.$store.state.tempCode = this.code
        let result = await UserConn.verifyRegister(this.code)
        if (!result.error) {
          if(!this.$store.state.validationOrigin || this.$store.state.validationOrigin !== 'forgot') {
            //auto login
            let userTemp = localStorage.getItem('tempMail')
            let passTemp = localStorage.getItem('tempPass')
            if (userTemp && passTemp) {
              let result2 = await UserConn.doLogin(userTemp, passTemp)
              console.log(result2)
              if (result2.error) {
                this.$store.state.showLoading = false
                EventBus.$emit('showAlert', 'error', 'Usuário e/ou senha inválidos')
              } else {
                localStorage.setItem('tempMail', null)
                localStorage.setItem('tempPass', null)
                if (this.$store.state.registerLoginOrigin === 'cart'){
                  this.$router.push({path: '/cart'})
                } else if (this.$store.state.registerLoginOrigin === 'history'){
                  this.$router.push({path: '/history'})
                } else {
                  this.$router.push({path: '/home'})
                }
              }
            } else {
              this.$router.push({path: '/login'})
            }
          } else {
            this.$store.state.showLoading = false
            this.$router.push({path: '/changePass'})
          }
        } else {
          this.$store.state.showLoading = false
          EventBus.$emit('showAlert', 'error', result.msg)
        }
      }
    },

    async reSendValidationCode () {
      this.$store.state.showLoading = true
      let result = await UserConn.resendValidationCode()
      if (result.error) {
        EventBus.$emit('showAlert', 'error', result.msg)
      } else {
        EventBus.$emit('showAlert', 'success', 'Um novo código foi enviado ao seu email/celular')
      }
      this.$store.state.showLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>

.form_container {
  position:relative;
  width: 100%;
  max-width:434px;
  line-height: 20px;
  margin: 0px auto;
}
.container_val {
  width:100vw;
  // max-width: 1330px;
  min-height: 100vh;
  background-color:#FFFFFF;
}
.header{
  // max-width: 1330px;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  height: 46px;
  text-align:right;
  top: 10px;
}


.inputFormText {
    width: 100%;
    font-size:16px;
    height:30px;
    padding-left:40px;
    color: #2C2A29;
    background-color: transparent;
    border:0px;
    border-bottom: 1px solid #2C2A29;
  }
.imgInputIcon {
    position:relative;
    left:5px;
    top:26px;
    font-size:16px;
  }

  .imgSelectIcon {
    font-size:16px;
    margin-left:5px;
  }

  input::placeholder {
    font-size:16px;
    //color: #2C2A29;
  }

  input:focus {
    outline: none;
    border:0px;
    border-bottom: 1px solid #5E2B8B;
  }
</style>
